"use client";
import { RegisterBilholdLightTheme } from "./bilholdLight/index.js";
import { RegisterBrandlessTheme } from "./brandless/index.js";
import { RegisterGumpenTheme } from "./gumpen/index.js";
import { RegisterMollerBilTheme } from "./mollerBil/index.js";
import { RegisterNyeMollerBilTheme } from "./nyeMollerBil/index.js";
import { RegisterSkodaDarkTheme } from "./skodaDark/index.js";
import { RegisterVolkswagenTheme } from "./vw/index.js";
import { RegisterDahlesTheme } from "./dahles/index.js";
import { RegisterAutoriaTheme } from "./autoria/index.js";
import { RegisterAudiTheme } from "./audi/index.js";
import { RegisterCupraTheme } from "./cupra/index.js";
import { audiThemeClass, autoriaThemeClass, bilholdLightThemeClass, brandlessThemeClass, cupraThemeClass, dahlesThemeClass, gumpenThemeClass, mollerBilThemeClass, nyeMollerBilThemeClass, skodaDarkThemeClass, volkswagenThemeClass } from "./themeNames/index.js";
import { RegisterAllThemesAndDefaults } from "./RegisterAllThemesAndDefaults.js";
import { DefaultGlobalStyles } from "./DefaultGlobalStyles.js";
export {
  DefaultGlobalStyles,
  RegisterAllThemesAndDefaults,
  RegisterAudiTheme,
  RegisterAutoriaTheme,
  RegisterBilholdLightTheme,
  RegisterBrandlessTheme,
  RegisterCupraTheme,
  RegisterDahlesTheme,
  RegisterGumpenTheme,
  RegisterMollerBilTheme,
  RegisterNyeMollerBilTheme,
  RegisterSkodaDarkTheme,
  RegisterVolkswagenTheme,
  audiThemeClass,
  autoriaThemeClass,
  bilholdLightThemeClass,
  brandlessThemeClass,
  cupraThemeClass,
  dahlesThemeClass,
  gumpenThemeClass,
  mollerBilThemeClass,
  nyeMollerBilThemeClass,
  skodaDarkThemeClass,
  volkswagenThemeClass
};
